import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  AgendaDataService,
  AgendaService,
  AgendaSocketService,
  EstabelecimentoDataService,
  ProfissionalService,
  TipoServicoService,
} from '@nomoh-monorepo/data-access-bardo-administrador';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { TabsModule } from 'primeng/tabs';
import { AgendaCalendarioComponent } from './components/agenda-calendario/agenda-calendario.component';

@Component({
  selector: 'lib-agenda',
  standalone: true,
  imports: [
    CommonModule,
    TabsModule,
    AgendaCalendarioComponent,
    BadgeModule,
    OverlayBadgeModule,
  ],
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss'],
})
export class AgendaComponent implements OnInit, OnDestroy {
  //#region Injeção de dependências
  AgendaService = inject(AgendaService);
  AgendaSocketService = inject(AgendaSocketService);
  private agendaDataService = inject(AgendaDataService);
  private estabelecimentoDataService = inject(EstabelecimentoDataService);
  private tipoServicoService = inject(TipoServicoService);
  private profissionalService = inject(ProfissionalService);
  //#endregion

  ngOnInit(): void {
    this.agendaDataService.setDataSelecionada(new Date());
    // Conectar ao websocket da Agenda
    this.AgendaSocketService.iniciar();
    this.carregarDadosDeApoio();
  }

  /**
   * A tela de Agenda depende de TipoServicoDataService e ProfissionalDataService
   * (categorias/serviços/profissionais) para os dropdowns de novo agendamento e
   * filtros. Esse estado só era carregado pelas telas de Estabelecimentos
   * (Categoria de Serviços / Profissionais) — inacessíveis para o perfil
   * PROFISSIONAL (sem Bardo.estabelecimentos.list) — então os dropdowns nunca
   * eram preenchidos para esse perfil. Carregamos aqui direto.
   */
  private carregarDadosDeApoio(): void {
    const estabelecimentoId =
      this.estabelecimentoDataService.$estabelecimentoAtual()?.id;
    if (!estabelecimentoId) {
      return;
    }
    this.tipoServicoService.findAll({ estabelecimentoId });
    this.profissionalService.findAll({ estabelecimentoId });
  }

  ngOnDestroy(): void {
    // Desconectar ao sair da aba da Agenda 
    this.AgendaSocketService.parar();
  }
}
